import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetMetricsResponse } from '../interfaces/get-metrics';
import { RequestError } from '../../../interfaces/error.interface';
import moment, { Moment } from 'moment';
import { MetricType } from '../../../interfaces/metricType.interface';
import { GetMetricTypesResponse } from '../interfaces/get-metric-types';
import { GraphType } from '../../../interfaces/graphType.interface';
import { GetGraphTypesResponse } from '../interfaces/get-graph-types';
import { Metrics } from '../../../interfaces/metrics.interface';

export interface MetricsState {
  metricTypes: MetricType[];
  metricType: MetricType | null;
  graphTypes: GraphType[];
  graphType: GraphType | null;
  grid: any[];
  overview: any[];
  counters: any[];
  distributions: any[];
  products: any[];
  dateInit: Moment | null;
  dateEnd: Moment | null;
  store: string;
  errorCode: number | null;
}

const initialState: MetricsState = {
  metricTypes: [],
  metricType: null,
  graphTypes: [],
  graphType: null,
  dateInit: moment().subtract(1, 'days'), // ✅ Ayer (día anterior)
  dateEnd: moment().subtract(1, 'days'), // ✅ Ayer (día anterior)
  store: 'todos',
  grid: [],
  overview: [],
  counters: [],
  distributions: [],
  products: [],
  errorCode: null,
};

const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {
    getMetricsInitApiAction: (state) => {
      state.errorCode = null;
    },
    getMetricsSuccessApiAction: (state, action: PayloadAction<Metrics>) => {
      state.grid = action.payload.grid;
      state.overview = [action.payload.overview];
      state.counters = action.payload.counters;
      state.distributions = action.payload.distributions;
      state.products = action.payload.products;
    },
    getMetricsFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getMetricTypesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getMetricTypesSuccessApiAction: (state, action: PayloadAction<MetricType[]>) => {
      console.log(action.payload)
      state.metricTypes = action.payload
    },
    getMetricTypesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getGraphTypesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getGraphTypesSuccessApiAction: (state, action: PayloadAction<GetGraphTypesResponse>) => {
      state.graphTypes = action.payload.graphs;
    },
    getGraphTypesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postMetricsInitApiAction: (state) => {
      state.errorCode = null;
    },
    postMetricsSuccessApiAction: () => { },
    postMetricsFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    setInitDateAction: (state, action: PayloadAction<Moment | null>) => {
      state.dateInit = action.payload;
    },
    setStoreAction: (state, action: PayloadAction<string>) => {
      state.store = action.payload;
    },
    setMetricTypeAction: (state, action: PayloadAction<MetricType | null>) => {
      state.metricType = action.payload;
    },
    setGraphTypeAction: (state, action: PayloadAction<GraphType | null>) => {
      state.graphType = action.payload;
    },
    setEndDateAction: (state, action: PayloadAction<Moment | null>) => {
      state.dateEnd = action.payload;
    },
    metricsClearAction: (state) => {
      state.metricTypes = [];
      state.metricType = null;
      state.graphTypes = [];
      state.graphType = null;
      state.dateInit = moment().subtract(1, 'days'); // ✅ Ayer (día anterior)
      state.dateEnd = moment().subtract(1, 'days'); // ✅ Ayer (día anterior)
      state.store = '';
      state.grid = [];
      state.overview = [];
      state.counters = [];
      state.distributions = [];
      state.products = [];
      state.errorCode = null;
    },
    postMetricTypeInitApiAction: () => { },
    postMetricTypeSuccessApiAction: () => { },
    postMetricTypeFailuireApiAction: () => { },
    putMetricTypeInitApiAction: () => { },
    putMetricTypeSuccessApiAction: () => { },
    putMetricTypeFailuireApiAction: () => { },
    putGraphTypeInitApiAction: () => { },
    putGraphTypeSuccessApiAction: () => { },
    putGraphTypeFailuireApiAction: () => { },
    deleteMetricTypeInitApiAction: () => { },
    deleteMetricTypeSuccessApiAction: () => { },
    deleteMetricTypeFailuireApiAction: () => { },
  },
});

export const {
  getMetricsInitApiAction,
  getMetricsSuccessApiAction,
  getMetricsFailureApiAction,
  setInitDateAction,
  setEndDateAction,
  setStoreAction,
  metricsClearAction,
  getMetricTypesInitApiAction,
  getMetricTypesSuccessApiAction,
  getMetricTypesFailureApiAction,
  getGraphTypesInitApiAction,
  getGraphTypesSuccessApiAction,
  getGraphTypesFailureApiAction,
  postMetricTypeInitApiAction,
  postMetricTypeSuccessApiAction,
  postMetricTypeFailuireApiAction,
  putMetricTypeInitApiAction,
  putMetricTypeSuccessApiAction,
  putMetricTypeFailuireApiAction,
  putGraphTypeInitApiAction,
  putGraphTypeSuccessApiAction,
  putGraphTypeFailuireApiAction,
  deleteMetricTypeInitApiAction,
  deleteMetricTypeSuccessApiAction,
  deleteMetricTypeFailuireApiAction,
  postMetricsInitApiAction,
  postMetricsSuccessApiAction,
  postMetricsFailureApiAction,
  setMetricTypeAction,
  setGraphTypeAction,
} = metricsSlice.actions;

export default metricsSlice.reducer;
